import { render, staticRenderFns } from "./flexigoLoader.vue?vue&type=template&id=014ffa0c&scoped=true"
import script from "./flexigoLoader.vue?vue&type=script&lang=js"
export * from "./flexigoLoader.vue?vue&type=script&lang=js"
import style0 from "./flexigoLoader.vue?vue&type=style&index=0&id=014ffa0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ffa0c",
  null
  
)

export default component.exports